<div
  class="changelog-header"
  *ngIf="changelog">
  <div class="modal-window__title changelog-modal-title">
    <mat-icon svgIcon="version"></mat-icon>
    <span class="changelog-modal-title-text">{{ changelog.description }}</span>
  </div>
</div>
<mat-divider class="changelog-h-divider"></mat-divider>

<mat-expansion-panel
  *ngFor="let version of changelog?.versions"
  class="modal-window__label changelog-modal-content">
  <mat-expansion-panel-header class="changelog-expansion-panel-header">
    <mat-panel-title>
      {{ version.title }}
    </mat-panel-title>
    <mat-panel-description> Date: {{ version.date }} </mat-panel-description>
  </mat-expansion-panel-header>

  <div *ngIf="version.changelogs?.length">
    <div *ngFor="let log of version.changelogs">
      <p class="changelog-version-title">
        <mat-icon
          [svgIcon]="getChangelogCategoryIcon(log)"
          class="changelog-change-type-icon"></mat-icon
        >{{ log.title }}
      </p>
      <ul class="changelog-version-items">
        <li
          *ngFor="let item of log.logs"
          class="changelog-version-item">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</mat-expansion-panel>

<div class="changelog-modal-action col-12 col-md-3 u-mt--medium">
  <button
    type="submit"
    class="button--sm button-primary button-block"
    (click)="onClose()">
    {{ "button.close" | translate }}
  </button>
</div>
